import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { retrieveEventCalendar } from "../../redux/slice/event-calendar-slice";
import { RootState, useAppDispatch } from "../../redux/store";
import TwoColumnList from "../../components/re-usable/two-column-list/two-column-list";
import Calendar from "../../components/re-usable/calendar/calendar";

const CalendarEvents = () => {
  const { data, loading } = useSelector((state: RootState) => state.eventCalendar);

  let date = new Date();

  let formattedDate = date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear();
  const [activeDate, setActiveDate] = useState<string>(formattedDate);

  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(retrieveEventCalendar(encodeURIComponent(activeDate)));
  }, [activeDate]);

  return (
    <div className=" bgevents">
      <div className="container " style={{ paddingBottom: 50 }}>
        <p>&nbsp;</p>
        <div className="events-section">
          <span>
            {" "}
            <a href="/events" className="more blueLettersAll seealleventsright">
              All
            </a>
          </span>
          <div className="col-md-6 col-sm-7 col-xs-8  cal-padding-0">
            <h2 className="sub-heading">
              <a href="/events">Events</a>
            </h2>
          </div>
          <div className="clear"></div>
          <div className="row events-inner-wrapper">
            <div className="col-lg-7 col-md-12 ipad-fulscreen-events cal-padding-2">
              <div className="row">
                {data?.eventInfoItemsList?.map((item, index) => {
                    let loc = item.city != "" ? `| ${item.city}, ${item.country}` : "";
                    return <TwoColumnList title={item.eventName} subTitle={item.formattedStartDate} location={ loc } titleUrl={item.nodeName} buttonTitle="REGISTER" buttonUrl={item.registrationUrl} key={index} />;
                })}
              </div>
            </div>
            <div className="col-md-5 ">
              <div className="event-calendar Calendar calendar_pad">
                <div>
                  <Calendar parentDate={activeDate} setParentDate={setActiveDate} />
                </div>
                <div className="col-md-12 col-sm-12 col-xs-12 text-right">
                  <a href="/events" className="btn btn-default">
                    <span>See All Events</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CalendarEvents;
